import SHOrgDialog from './src/dialog.vue';

/* istanbul ignore next */
SHOrgDialog.install = function(Vue) {
  Vue.component('sh-org-dialog', SHOrgDialog);
};

export default SHOrgDialog;



// WEBPACK FOOTER //
// ./src/components/base/view/Org/cmps/org/dialog/index.js